export default __webpack_public_path__ + "static/media/hamam2.a96e58cd.png";